import React from 'react';
import { useTranslation } from 'react-i18next';

// Shown briefly while a lazy-loaded route's chunk downloads — same plain
// style already used for the auth-check loading state in router.jsx, so a
// route transition and an auth check look the same rather than introducing
// a second loading pattern.
export default function PageLoadingFallback() {
  const { t } = useTranslation();
  return (
    <div className="flex items-center justify-center h-screen text-gray-400">{t('common:components.pageLoadingFallback.loading', 'Loading…')}</div>
  );
}
